/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES clipping 料金システム用 API
 * PR TIMES clipping 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostClippingResearchBillingBody
 */
export interface PostClippingResearchBillingBody {
    /**
     * 企業ID
     * @type {number}
     * @memberof PostClippingResearchBillingBody
     */
    companyId: number;
    /**
     * クリップID
     * @type {number}
     * @memberof PostClippingResearchBillingBody
     */
    clipId: number;
    /**
     * クリップ開始日。Y-m-d H:i:s形式。
     * @type {string}
     * @memberof PostClippingResearchBillingBody
     */
    clipStartAt: string;
}

export function PostClippingResearchBillingBodyFromJSON(json: any): PostClippingResearchBillingBody {
    return PostClippingResearchBillingBodyFromJSONTyped(json, false);
}

export function PostClippingResearchBillingBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostClippingResearchBillingBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'clipId': json['clip_id'],
        'clipStartAt': json['clip_start_at'],
    };
}

export function PostClippingResearchBillingBodyToJSON(value?: PostClippingResearchBillingBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'company_id': value.companyId,
        'clip_id': value.clipId,
        'clip_start_at': value.clipStartAt,
    };
}

